import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgMinusCircle = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M17 13H7a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm8-10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z", fill: color })));
};
export default factorySvgIcon(SvgMinusCircle);
//# sourceMappingURL=SvgMinusCircle.js.map